export function checkIsDefaultSelectName(name: string) {
  return name.includes('Select_')
}
